export const challenges = {
  social: [
    { text: "Ask a stranger in line what they're cooking for dinner", points: 4 },
    { text: "Ask a stranger their opinion on pigeons", points: 5 },
    { text: "Compliment a stranger's shoes or outfit unprompted", points: 3 },
    { text: "Ask a stranger for a random recommendation (restaurant, book, etc)", points: 4 },
    { text: "Send a cold DM to someone you admire with a specific compliment", points: 5 },
    { text: "Ask for a discount by saying 'What's your best price on this?'", points: 4 },
    { text: "Call someone instead of texting for your next communication", points: 3 },
    { text: "Defuse an awkward situation by saying something completely absurd", points: 6 },
    { text: "Text 3 friends right now to hang out tonight (no planning)", points: 5 },
    { text: "Introduce yourself to someone at a coffee shop/bar", points: 4 },
    { text: "Share your actual unpopular opinion in a group conversation", points: 5 },
    { text: "Ask someone 'what's the weirdest thing that happened to you this week?'", points: 3 },
    { text: "Invite someone you barely know to join you for something", points: 5 },
    { text: "Tell someone a genuine compliment you've been holding back", points: 4 },
    { text: "Start a conversation with 'this might sound weird but...'", points: 4 },
    { text: "Ask someone 'if you could do anything right now, what would it be?'", points: 3 },
    { text: "Share an embarrassing story about yourself unprompted", points: 5 },
    { text: "Ask a service worker how their day is going and actually listen", points: 3 },
    { text: "Tell someone 'I want to be friends with you' directly", points: 6 },
    { text: "Post your phone number publicly for networking/making friends", points: 7 },
    { text: "Call someone you've been texting for weeks instead of typing another message", points: 4 },
    { text: "Tell someone 'no' without explaining or apologizing", points: 5 },
    { text: "Ask someone what they REALLY think of you (and don't defend yourself)", points: 6 },
    { text: "Disagree out loud in a meeting/conversation where everyone else agrees", points: 6 },
    { text: "Post a selfie with zero filters, zero caption - just your face", points: 5 },
    { text: "Ask someone to hang out who you think is 'too cool' for you", points: 5 },
    { text: "Admit you were wrong about something publicly", points: 5 },
    { text: "Start a conversation by asking 'what's something you believe that most people disagree with?'", points: 5 }
  ],
  creative: [
    { text: "Publish that half-finished blog post/project TODAY", points: 6 },
    { text: "Set a 15-minute timer, make something, then post it immediately", points: 5 },
    { text: "Record a voice note about your dumbest idea and send it to 3 people", points: 4 },
    { text: "Write the intentionally worst version of something, then ship it", points: 5 },
    { text: "Post your actual unfiltered thoughts with zero editing", points: 4 },
    { text: "Create and share something in the next 60 minutes (no overthinking)", points: 6 },
    { text: "Make a video of yourself explaining your weird hobby/interest", points: 5 },
    { text: "Write and publish a 200-word essay on your shower thoughts", points: 4 },
    { text: "Draw/create something and post it with zero explanation", points: 4 },
    { text: "Start that creative project you said you'd do 'when you have time'", points: 5 },
    { text: "Record yourself singing/performing and send it to 5 people", points: 6 },
    { text: "Write a strongly-worded opinion piece and publish it somewhere", points: 5 },
    { text: "Make a meme about your current situation and share it publicly", points: 3 },
    { text: "Start a blog/newsletter/channel you've been planning for months", points: 7 },
    { text: "Share your creative work in a place where people will judge it", points: 6 },
    { text: "Make something intentionally bad and post it as if it's good", points: 5 },
    { text: "Turn your worst idea into something real in the next hour", points: 6 },
    { text: "Comment/reply on 10 posts from creators you admire", points: 4 },
    { text: "Make a tutorial about something you barely understand", points: 5 },
    { text: "Remix someone else's work and send it to them", points: 5 },
    { text: "Post the draft you've been 'almost done with' for months - ship it incomplete", points: 6 },
    { text: "Delete your perfectionist version and start from scratch with 30 min timer", points: 6 },
    { text: "Create something intentionally bad and post it seriously", points: 5 },
    { text: "DM your work to someone who intimidates you", points: 6 },
    { text: "Say your hot take out loud in a group conversation", points: 5 },
    { text: "Make a tutorial for something you barely understand", points: 5 },
    { text: "Post your revenue/metrics publicly (if you're hiding them out of shame)", points: 7 }
  ],
  money: [
    { text: "Launch that 'saturated' offer everyone says won't work", points: 8 },
    { text: "Pitch a price 50% higher than you normally would", points: 7 },
    { text: "Say yes to a sketchy-seeming client you'd normally screen out", points: 6 },
    { text: "Ask your boss for a specific raise amount TODAY", points: 7 },
    { text: "Deploy that domain you bought 6 months ago with SOMETHING on it", points: 6 },
    { text: "Send 5 cold emails to dream clients/collaborators", points: 5 },
    { text: "Make an offer on something you 'can't quite afford'", points: 7 },
    { text: "DM someone successful: 'Can I get 15 min of your time?'", points: 5 },
    { text: "Apply to that job where you only meet 60% of requirements", points: 6 },
    { text: "Ask for payment upfront on your next project/gig", points: 5 },
    { text: "List something for sale that you've been hoarding", points: 4 },
    { text: "Negotiate on something you'd normally pay full price for", points: 4 },
    { text: "Ask for a refund/credit on something mediocre you accepted", points: 5 },
    { text: "Pitch your idea/service to 3 strangers today", points: 6 },
    { text: "Start selling that skill you think 'everyone already knows'", points: 6 },
    { text: "Double your freelance rate starting with your next proposal", points: 7 },
    { text: "Ask someone making more than you exactly how much they make", points: 5 },
    { text: "Buy the premium/expensive version instead of cheaping out", points: 6 },
    { text: "Invest in yourself (course/tool/coach) you've been delaying", points: 6 },
    { text: "Quit the client/job that's underpaying you", points: 8 },
    { text: "Charge for something you normally do for free", points: 6 },
    { text: "Cancel a subscription you've been 'meaning to' cancel for months", points: 3 },
    { text: "Buy the premium version of something you've been cheaping out on", points: 5 },
    { text: "Ask for a discount on something that 'doesn't have discounts'", points: 5 },
    { text: "Sell something you've been hoarding 'just in case'", points: 4 },
    { text: "Invest $X in yourself today (course/tool/upgrade) - no research, just pick one", points: 6 },
    { text: "Send an invoice for unpaid work you gave up on collecting", points: 6 },
    { text: "Raise your rate/price RIGHT NOW for your next client", points: 6 }
  ],
  gym: [
    { text: "Go to the gym in whatever you're wearing right now", points: 4 },
    { text: "Try the exercise that intimidates you most", points: 5 },
    { text: "Ask someone for a spot without overthinking it", points: 3 },
    { text: "Do that workout you've been 'saving for later'", points: 4 },
    { text: "Go to the gym at a completely different time than usual", points: 3 },
    { text: "Try a new piece of equipment you've never touched", points: 4 },
    { text: "Work out in the busiest area of the gym", points: 5 },
    { text: "Sign up for a class that scares you", points: 5 },
    { text: "Ask the biggest person in the gym for advice", points: 4 },
    { text: "Do your workout outside/in public instead of the gym", points: 4 },
    { text: "Try the weight that feels 'too heavy' for you", points: 5 },
    { text: "Go for a run right now, no warmup, no playlist prep", points: 4 },
    { text: "Work out with zero music or podcasts, just raw discomfort", points: 5 },
    { text: "Do the workout you're worst at", points: 4 },
    { text: "Join a pickup game/sport with people you don't know", points: 5 },
    { text: "Work out for 10 minutes right now wherever you are", points: 3 },
    { text: "Sign up for that race/competition you've been avoiding", points: 6 },
    { text: "Cancel your plans and go work out instead", points: 4 },
    { text: "Work out twice today just because", points: 5 },
    { text: "Do 100 pushups/squats right now, break them up however", points: 4 },
    { text: "Do 50 burpees right now, wherever you are", points: 5 },
    { text: "Go to the gym and ask the most jacked person for their program", points: 5 },
    { text: "Work out in jeans/dress clothes - no changing", points: 5 },
    { text: "Try the weight that feels 'too heavy' right now", points: 5 },
    { text: "Run a mile without checking your pace/time once", points: 4 },
    { text: "Do your workout outside where people can see you", points: 4 },
    { text: "Sign up for something competitive (race/comp) happening within 30 days", points: 6 }
  ],
  "anti-opt": [
    { text: "Do the OPPOSITE of your morning routine today", points: 4 },
    { text: "Eat the 'bad' food you've been avoiding (seed oils be damned)", points: 3 },
    { text: "Skip your entire routine and just GO", points: 5 },
    { text: "Stop researching that thing and START doing it in next hour", points: 6 },
    { text: "Delete your optimization spreadsheet/notion doc", points: 5 },
    { text: "Say YES to the next 3 invitations no matter what they are", points: 6 },
    { text: "Spend money on something fun instead of 'investing' it", points: 4 },
    { text: "Cancel your productivity block for spontaneous adventure", points: 5 },
    { text: "Stop tracking whatever you're obsessively tracking for a week", points: 5 },
    { text: "Do something inefficient just because it sounds fun", points: 4 },
    { text: "Ignore your todo list entirely and do what you WANT to do", points: 4 },
    { text: "Uninstall your habit tracking app", points: 5 },
    { text: "Buy the 'suboptimal' option because you like it more", points: 4 },
    { text: "Skip your supplement/biohacking routine for pure chaos", points: 3 },
    { text: "Do something you know is 'inefficient' to prove you can", points: 4 },
    { text: "Stop optimizing your sleep and just go to bed when tired", points: 4 },
    { text: "Eat when hungry, not when your meal plan says to", points: 3 },
    { text: "Delete that productivity app you never actually use", points: 3 },
    { text: "Make a decision in under 10 seconds that you'd normally research", points: 5 },
    { text: "Do the 'wrong' version of something you've been perfecting", points: 5 },
    { text: "Delete your productivity app and wing it for a week", points: 5 },
    { text: "Say yes to the next 3 things you'd normally research first", points: 6 },
    { text: "Unsubscribe from all optimization newsletters/podcasts for a month", points: 5 },
    { text: "Stop tracking X (sleep/macros/steps) for a week", points: 4 },
    { text: "Do the 'inefficient' option because it sounds more fun", points: 4 },
    { text: "Spend money on something purely for enjoyment (not 'investment')", points: 4 },
    { text: "Cancel the 'productive' thing and do the fun thing instead", points: 5 }
  ],
  chaos: [
    { text: "Say yes to the very next invitation with zero hesitation", points: 4 },
    { text: "Take a completely random route to your destination", points: 2 },
    { text: "Order the weirdest thing on the menu you've never tried", points: 3 },
    { text: "Do that task you've avoided for months RIGHT NOW", points: 5 },
    { text: "Flip a coin for your next decision and honor it", points: 4 },
    { text: "Go to gym/workout in exactly what you're wearing now", points: 4 },
    { text: "Text your most unhinged idea to a friend and commit to it", points: 6 },
    { text: "Book a trip/experience for this weekend right now", points: 6 },
    { text: "Delete the app you waste the most time on", points: 5 },
    { text: "Start a conversation with 'this is going to sound crazy but...'", points: 4 },
    { text: "Do something your past self would think is insane", points: 5 },
    { text: "Make a major change to your appearance (haircut, style, etc)", points: 6 },
    { text: "Say the thing you've been too scared to say", points: 6 },
    { text: "Throw away/donate something you've been hoarding", points: 4 },
    { text: "Go somewhere you've never been in your city TODAY", points: 4 },
    { text: "Send a risky text you've had drafted for days/weeks", points: 5 },
    { text: "Do the exact thing your anxiety is telling you not to do", points: 6 },
    { text: "Change one big thing about your daily routine permanently", points: 5 },
    { text: "Commit to something before you're 'ready'", points: 5 },
    { text: "Take the riskier option just to see what happens", points: 5 },
    { text: "Book a one-way ticket somewhere for next month (figure it out later)", points: 8 },
    { text: "Quit something you've been tolerating out of obligation", points: 7 },
    { text: "Say the truth instead of the polite lie you were about to tell", points: 5 },
    { text: "Do that dangerous/stupid thing your friends warned you about", points: 7 },
    { text: "Change your appearance drastically (haircut/style/piercing)", points: 6 },
    { text: "Delete the app you waste the most time on (yes, right now)", points: 5 },
    { text: "Start the conversation you've been avoiding for months", points: 6 }
  ]
};

export const weeklySpecialChallenges = [
  { text: "Post that hot take you've been sitting on for months", points: 8, category: 'creative' },
  { text: "Ask out your crush TODAY (no planning, no rehearsing)", points: 9, category: 'social' },
  { text: "Quit that thing you hate but have been too scared to leave", points: 10, category: 'chaos' },
  { text: "Launch a half-baked business idea this weekend", points: 9, category: 'money' },
  { text: "Delete your most-used time-wasting app for entire week", points: 6, category: 'anti-opt' },
  { text: "Cancel all routines for a week of pure spontaneity", points: 7, category: 'anti-opt' },
  { text: "Say yes to EVERY social invitation for 7 days straight", points: 8, category: 'social' },
  { text: "Post something personal/vulnerable every day this week", points: 8, category: 'creative' },
  { text: "Cold email/DM 50 people about your idea/project", points: 9, category: 'money' },
  { text: "Start that 'someday' project and ship version 1.0 this week", points: 9, category: 'creative' },
  { text: "Go to 3 new places this week you've never been", points: 7, category: 'chaos' },
  { text: "Have 10 conversations with strangers this week", points: 8, category: 'social' },
  { text: "Make and post something every single day for a week", points: 8, category: 'creative' },
  { text: "Ask for what you want from 5 different people this week", points: 8, category: 'social' },
  { text: "Do the thing you're most scared of right now", points: 10, category: 'chaos' }
];

export const hardModeChallenges = {
  social: [
    { text: "Walk up to a group of strangers mid-conversation and introduce yourself", points: 10 },
    { text: "Tell someone you just met something genuinely vulnerable about yourself", points: 11 },
    { text: "Stand up in a public place and make an announcement to the room", points: 12 },
    { text: "Call your most intimidating contact and pitch yourself or your idea", points: 11 },
    { text: "Post a public apology to someone you wronged — on social media", points: 12 },
    { text: "Ask a stranger: 'What's the one thing holding you back right now?'", points: 10 },
    { text: "Tell someone they're wrong about something — to their face, in public", points: 11 },
    { text: "DM the most successful person you follow and ask for 10 minutes of their time", points: 12 },
    { text: "Start a conversation with someone and end it by saying 'I think you're going to do great things'", points: 10 },
    { text: "Ask a stranger what they think of you after a 5-minute conversation", points: 13 },
  ],
  creative: [
    { text: "Publish something you've been afraid to ship for over a month — right now", points: 10 },
    { text: "Post a video of yourself sharing your most controversial creative opinion", points: 11 },
    { text: "Share your half-finished project publicly and ask for brutal feedback", points: 10 },
    { text: "Write and send a cold pitch to a publication, label, or brand you admire", points: 11 },
    { text: "Create something live in front of people (stream, open mic, whatever)", points: 13 },
    { text: "Post your most personal piece of creative work with zero explanation", points: 12 },
    { text: "Commission or collaborate with someone who intimidates you creatively", points: 11 },
    { text: "Submit your work to a competition or open call you think you'll lose", points: 10 },
    { text: "Delete your 3 oldest posts and replace them with something better today", points: 11 },
    { text: "Record yourself performing something live and post it unedited", points: 12 },
  ],
  money: [
    { text: "Raise your rate or price by 50% starting with the very next prospect", points: 12 },
    { text: "Fire your lowest-paying client or cut the job that's draining you", points: 13 },
    { text: "Send a proposal to your dream client — the one you think is out of reach", points: 11 },
    { text: "Go to a negotiation and don't accept the first 'no' — counter twice", points: 12 },
    { text: "Invest the amount of money you've been scared to invest", points: 12 },
    { text: "Set up a product, service, or listing and make it purchasable before midnight", points: 13 },
    { text: "Ask for a testimonial from every client you've ever worked with — today", points: 10 },
    { text: "Reach out to 10 strangers about your offer. Not DMs — phone calls", points: 13 },
    { text: "Apply for funding, a grant, or a loan you think you don't qualify for", points: 11 },
    { text: "Announce your price publicly and commit to it for 30 days", points: 12 },
  ],
  gym: [
    { text: "Show up to the gym and ask the strongest person there to train with you for the day", points: 10 },
    { text: "Do every exercise you've been avoiding for the last 3 months — in one session", points: 11 },
    { text: "Sign up for a race or competition happening within the next 30 days", points: 12 },
    { text: "Work out twice today — morning and evening — with no half-assing", points: 11 },
    { text: "Go to a class or sport where you'll be the worst person in the room", points: 10 },
    { text: "Do 200 bodyweight reps of anything — right now, no prep", points: 10 },
    { text: "Hit a new max on a lift you've been scared to push", points: 12 },
    { text: "Hire a trainer or sign up for a coached class with total strangers", points: 11 },
    { text: "Run or walk 5 miles today with zero excuses and zero music", points: 10 },
    { text: "Join a recreational sports league this week — no experience required", points: 12 },
  ],
  'anti-opt': [
    { text: "Delete every tracking app on your phone. No reinstalling for 7 days", points: 11 },
    { text: "Cancel your next 3 planned 'optimization' sessions and replace with spontaneous action", points: 10 },
    { text: "Go 48 hours with zero screen time for entertainment — books, people, or nothing", points: 12 },
    { text: "Throw away your morning routine entirely and see what actually matters", points: 11 },
    { text: "Unsubscribe from every newsletter, podcast, and productivity content in one sitting", points: 12 },
    { text: "Make a major life decision based only on how it feels right now, no research", points: 13 },
    { text: "Do the inefficient version of everything today — take the long way on purpose", points: 10 },
    { text: "Spend a full day doing only things that cannot be measured or optimized", points: 11 },
    { text: "Delete your notion/obsidian/second brain for a week. Build it back from memory", points: 12 },
    { text: "Go 72 hours without checking your metrics, stats, or progress on anything", points: 13 },
  ],
  chaos: [
    { text: "Book a trip somewhere you've never been — leave within 72 hours", points: 13 },
    { text: "Quit the thing you've been tolerating the longest. Today.", points: 14 },
    { text: "Say the most honest thing you've been holding back — to the person you've been holding it back from", points: 13 },
    { text: "Do the thing your gut has been screaming at you to do for months", points: 14 },
    { text: "Make the boldest change to your life you can execute before midnight", points: 13 },
    { text: "Reach out to someone you haven't spoken to in years with a real message", points: 10 },
    { text: "Go somewhere you'd normally never go, alone, with no plan", points: 11 },
    { text: "Commit to a decision that terrifies you — publicly", points: 13 },
    { text: "Delete or break the habit that you've failed to quit 3+ times before", points: 12 },
    { text: "Do something today that your past self would find completely unrecognizable", points: 12 },
  ],
};